export default "__VITE_ASSET__Aafg6fOv__"